function getPathLabel(path) {
    switch (path) {
        case 'Home':
            return 'Home';

        case 'dados_empresa':
            return 'Dados da empresa';

        case 'planos_valores':
            return 'Consultar planos e valores';

        case 'planos_valores_ativos':
            return 'Para beneficiários ativos';

        case 'planos_valores_aposentados_demitidos':
            return 'Para aposentados e demitidos';

        case 'dados_contrato':
            return 'Dados de contrato';

        case 'consultar_planos_valores':
            return 'Consultar planos e valores';

        case 'carta_reajuste':
            return 'Carta de reajuste';

        case 'aposentados_demitidos':
            return 'Para aposentados e demitidos';

        case 'selecionar_lotacao':
        case 'formulario_lotacao':
            return 'Lotação';

        case 'dados_beneficiario':
            return 'Dados de beneficiário';

        case 'relatorio_beneficiarios':
            return 'Relatório de beneficiários';

        case 'carta_de_permanencia':
            return 'Carta de permanência';

        case 'beneficiarios_por_congenere':
            return 'Beneficiários por congênere';

        case 'movimentacoes_arquivo':
            return 'Movimentações por arquivo';

        case 'editar_endereco':
        case 'informacoes':
            return 'Informações de cadastro';

        case 'gerenciar_usuarios':
            return 'Gerenciar usuários';

        case 'pesquisa_congeneres':
            return 'Pesquisa congêneres';

        case 'selecionar_beneficiario_dados':
        case 'beneficiario_dados':
            return 'Consultar beneficiário';

        case 'movimentacao_cadastral':
            return 'Movimentação cadastral';

        case 'adicionar_beneficiario':
        case 'adicionar_titular':
        case 'adicionar_dependente':
        case 'selecionar_titular':
        case 'upload_documentos':
        case 'revisar_dados':
        case 'validar_inclusao_beneficiario':
            return 'Adicionar beneficiário';

        case 'selecionar_beneficiario':
        case 'alterar_titular':
        case 'alterar_dependente':
        case 'validar_alteracao_beneficiario':
        case 'selecionar_alterar_beneficiario':
            return 'Alterar beneficiário';

        case 'selecionar_transferencia_beneficiario':
        case 'transferencia_beneficiario':
        case 'validar_transferencia_beneficiario':
            return 'Transferir beneficiário';

        case 'selecionar_desligar_beneficiario':
        case 'desligar_beneficiario':
        case 'validar_desligamento_beneficiario':
            return 'Desligar beneficiário';

        case 'selecionar_reativar_beneficiario':
        case 'reativar_beneficiario':
        case 'validar_reativar_beneficiario':
            return 'Reativar beneficiário';

        case 'selecionar_trocar_plano':
        case 'trocar_plano':
        case 'validar_trocar_plano':
            return 'Trocar o plano';

        case 'selecionar_aposentados_demitidos':
        case 'preencher_dados_aposentados_demitidos':
        case 'carregar_documentos_aposentados_demitidos':
        case 'aguardar_analise_aposentados_demitidos':
        case 'salvar_rascunho_aposentados_demitidos':
            return 'Aposentados e demitidos';

        case 'faturamento':
            return 'Faturamento';

        case 'consultar_faturas':
            return 'Consultar faturas';

        case 'selecionar_centro_custo':
        case 'formulario_centro_custo':
            return 'Centro de custo';

        case 'movimentacoes_pendentes':
            return 'Movimentações pendentes';

        case 'central_ajuda':
            return 'Central de ajuda';

        case 'materiais_apoio':
            return 'Materiais de apoio';

        case 'historico_movimentacao':
            return 'Histórico de movimentação';

        case 'selecionar_acao':
        case 'segunda_via':
        case 'carterinha_digital':
        case 'pesquisar_beneficiario':
        case 'sucesso_solicitacao':
            return 'Carteirinha';

        case 'lista_solicitacoes':
            return 'Lista de solicitações';

        case 'seleciona_beneficiario_imposto_renda':
        case 'demonstrativo_imposto_renda':
            return 'Demonstrativo de imposto de renda';

        case 'seleciona_beneficiario_coparticipacao':
        case 'demonstrativo_coparticipacao':
            return 'Demonstrativo de Coparticipação';

        case 'selecionar_beneficiario_franquia':
        case 'visualizar_tabela_franquia':
            return 'Tabela franquia';

        case 'selecionar_solicitacao_guias':
        case 'guias':
        case 'preencher_dados_solicitacao_guias':
        case 'carregar_documentos_solicitacao_guias':
        case 'validar_solicitacao_guias':
            return 'Solicitação de Guias';

        case 'pesquisa_rede':
        case 'seleciona_rede_assistencial':
            return 'Pesquisa Rede';

        case 'agendamento_consulta':
        case 'agendamento_consulta_dados':
        case 'agendamento_consulta_dados_consulta':
        case 'agendamento_consulta_medico':
        case 'agendamento_consulta_confirmar_dados':
            return 'Agendamento';

        case 'cancelamento_consulta':
        case 'lista_consulta_dados':
            return 'Cancelamento';

        case 'historico_consultas':
        case 'historico_consultas_dados':
            return 'Historico de Consultas';

        // case 'beneficiarios':
        //     return 'Beneficiários';

        // case 'faturamento':
        //     return 'Faturamento';

        // case 'ajuda':
        //     return 'Ajuda';

        default:
            return null;
    }
}

export default getPathLabel;
